import { useRef, useEffect } from 'react';

const useMainContent = () => {
    const mainContentRef = useRef(null);

    useEffect(() => {
        mainContentRef.current = document.getElementById('mainContent');
    }, []);

    return () => {
        if (mainContentRef.current) {
            mainContentRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'end',
            });
        }
    };
};

export default useMainContent;
